import { initPhoneInputMask } from '../utils/phone_input'
import { initLoadMoreButton } from '../utils/load_more_button'

let fetchUnitSizeBasedFacilities = (city, state, locationSegment, storage_type, page, unit_size, zip_code, amenity, neighborhood, size_slug) => {
  let params = `?page=${page}&unit_size=${unit_size}`;
  if (neighborhood) {
    params += `&filter_storage_type=${storage_type}`;
  }
  let actionUrl = `/${neighborhood ? 'self-storage' : storage_type}-${city}-${state}`;
  if (size_slug && storage_type === 'self-storage' && !neighborhood && !locationSegment) {
    actionUrl += `/${size_slug}`;
  }
  if(locationSegment){
    actionUrl = actionUrl + '/' + locationSegment;
  }
  actionUrl = actionUrl + '.js' + params;

  $.ajax(actionUrl, {
    method: 'GET',
    credentials: 'same-origin'
  }).done(() => {
    if (typeof window.fetchMapMarkers === 'function') {
      const mapArgs = [city, state, zip_code, amenity, storage_type, neighborhood, unit_size];
      if (size_slug) mapArgs.push(size_slug);
      window.fetchMapMarkers(...mapArgs);
    }
  }).fail(() => {
    $('#filter-error-message').text('We could not load these storage results. Please try again or choose another filter.').show();
  }).always(() => {
    hideLoader();
  })
}

let fetchPageResponse = function(unit_size) {
  let city = $('#city_param').val(),
    state = $('#state_param').val(),
    zip_code = $('#zip_param').val(),
    amenity = $('#amenity_param').val(),
    neighborhood = $('#neighborhood_param').val(),
    page = $('#page_param').val(),
    size_slug = $('#size_slug_param').val(),
    storage_type = $("[name='storage_type']:checked").val();
  const routeStorageType = $('#storage_type_param').val();
  if (storage_type === 'vehicle-storage' && ['car-storage', 'boat-storage', 'rv-storage', 'motorcycle-storage'].includes(routeStorageType)) {
    storage_type = routeStorageType;
  }
  if(page === '')
    page = 1;
  else
    page = parseInt(page);
  if (neighborhood) {
    page = 1;
    $('#page_param').val(1);
  }
  const locationSegment = neighborhood ? `neighborhood-${neighborhood}` : (amenity || zip_code);
  if (size_slug && !neighborhood && !amenity && !zip_code) {
    const currentSize = size_slug.replace(/-storage-units$/, '');
    if (storage_type !== 'self-storage' || unit_size !== currentSize) {
      const destination = storage_type === 'self-storage' && unit_size
        ? `/${unit_size}-storage-units`
        : '';
      window.location.href = `/${storage_type}-${city}-${state}${destination}`;
      hideLoader();
      return;
    }
  }
  fetchUnitSizeBasedFacilities(city, state, locationSegment, storage_type,
    page, unit_size, zip_code, amenity, neighborhood, size_slug);
}

let showLoader = function () {
  $('#filter-error-message').hide();
  $('.loading-overlay').show();
  $('.loading-overlay-image-container').show();
}

let hideLoader = function () {
  $('.loading-overlay').hide();
  $('.loading-overlay-image-container').hide();
}

$(function(){
  document.querySelectorAll(".city-page-faq button[data-toggle='collapse']").forEach(button => {
    button.addEventListener("click", function() {
      const accordion = this.closest(".myaccordion");
      const isOpening = this.getAttribute("aria-expanded") !== "true";

      accordion.querySelectorAll(".fa-stack i:last-child").forEach(icon => {
        icon.classList.remove("fa-minus");
        icon.classList.add("fa-plus");
      });

      if (isOpening) {
        const icon = this.querySelector(".fa-stack i:last-child");
        icon.classList.remove("fa-plus");
        icon.classList.add("fa-minus");
      }
    });
  });

  $(".filter-btn").click(function(){
    $(".filter-overlay").toggleClass("active");
    $(".filters-detail").slideToggle();
  });

  $(".filters-detail .close-btn").click(function(){
    $(".filter-overlay").removeClass("active");
    $(".filters-detail").slideToggle();
  });

  $("#self-storage-btn").click(function(){
    $("#all-size").prop('checked', true).trigger('change');
    $("#self-storage").addClass("active");
    $("#self-storage").show();
    $("#vehicle-storage").hide();
  });

  $("#vehicle-storage-btn").click(function(){
    $("#all-size").prop('checked', true).trigger('change');
    $("#vehicle-storage").show();
    $("#self-storage").hide();
  });

  $(".apply-btn").on('click', function(){
    showLoader();
    let unit_size = $("[name='unit_size']:checked").val();
    fetchPageResponse(unit_size);
    $(".filters-detail .close-btn").trigger('click');
  });

  initLoadMoreButton({
    pageFieldSelector: '#page_param',
    onBeforeSend: () => {
      showLoader();
    },
    onFail: () => {
      hideLoader();
    }
  });

  $("[name='unit_size']").on('change', function(){
    if(!window.matchMedia("only screen and (max-width: 991px)").matches){
      showLoader();
      fetchPageResponse($(this).val());
    }
  });

  $(".reset-btn").on('click', function(){
    const defaultType = $('.filters-detail').data('default-storage-type');
    const sizeSlug = $('#size_slug_param').val();
    const defaultSize = sizeSlug ? sizeSlug.replace(/-storage-units$/, '') : '';
    if (sizeSlug) {
      const defaultButton = defaultType === 'vehicle-storage' ? '#vehicle-storage-btn' : '#self-storage-btn';
      $(defaultButton).prop('checked', true);
      $(defaultType === 'vehicle-storage' ? '#vehicle-storage' : '#self-storage').show();
      $(defaultType === 'vehicle-storage' ? '#self-storage' : '#vehicle-storage').hide();
      $(`[name='unit_size'][value="${defaultSize}"]`).prop('checked', true);
      showLoader();
      fetchPageResponse(defaultSize);
      $(".filters-detail .close-btn").trigger('click');
      return;
    }
    $(defaultType === 'vehicle-storage' ? '#vehicle-storage-btn' : '#self-storage-btn').trigger('click');
    if(window.matchMedia("only screen and (max-width: 991px)").matches){
      showLoader();
      fetchPageResponse($(this).val());
      $(".filters-detail .close-btn").trigger('click');
    }
  });

  initPhoneInputMask();
});
